module.exports = __webpack_public_path__ + "static/2024-06-11-PZT_rys-v2-01-24dbd5115f2971a3172d23d5e856eda8.png";